import { TeachingTool } from './teaching-tool';

// A video is just a teaching tool with content-type set to video
export class Video extends TeachingTool {
    songTags: string

    get collections(): string[] {
        return (this.collection || '').split(',').map((value: string) => value.trim()).filter((value: string) => value.length > 0)
    }

    collectionsMatchAny(tags: string[]): boolean {
        return this.collections.some ((collectionTag: string) => {
            return tags.some((tag: string) => tag.toLowerCase() === collectionTag.toLowerCase() )
        })
    }

    songTagsList(): string[] {
        return (this.songTags || '').split(',').map((value: string) => value.trim()).filter((value: string) => value.length > 0)
    }

    songTagsMatchAny(tags: string[]): boolean {
        return this.songTagsList().some ((songTag: string) => {
            return tags.some((tag: string) => tag.toLowerCase() === songTag.toLowerCase() )
        })
    }

    static videosWithSongTags(videos: Video[], tags: string[]): Video[] {
        const results: Video[] = []
        videos.forEach((video: Video) => {
            if (video.songTagsMatchAny(tags)) {
                results.push(video)
            }
        })
        return results
    }

}
